import PropTypes from 'prop-types';
import { Global } from '@emotion/core';
import React from 'react';
import { ThemeProvider as TP } from 'emotion-theming';
import tokens from 'components/tokens';

const Reset = () =>
  React.createElement(Global, {
    styles: {
      html: {
        boxSizing: 'border-box',
        fontFamily: '"Inter", sans-serif',
      },
      '*, *:before, *:after': {
        boxSizing: 'inherit',
      },
      small: {
        fontSize: '100%',
      },
      button: {
        border: 0,
        padding: 0,
        fontSize: '100%',
        backgroundColor: 'transparent',
      },
      '*': {
        margin: '0',
        padding: '0',
        textDecoration: 'none',
        fontSize: '1em',
        outline: 'none',
      },
      'code, kbd, samp, pre, tt, var, textarea, input, select, isindex, listing, xmp, plaintext': {
        font: 'inherit',
        fontSize: '1em',
        whiteSpace: 'normal',
      },
      'dfn, i, cite, var, address, em': {
        fontStyle: 'normal',
      },
      'th, b, strong, h1, h2, h3, h4, h5, h6': {
        fontWeight: 'normal',
      },
      'a, img, a img, iframe, form, fieldset, abbr, acronym, object, applet, table': {
        border: 'none',
      },
      table: {
        borderCollapse: 'collapse',
        borderSpacing: '0',
      },
      'caption, th, td, center': {
        textAlign: 'left',
        verticalAlign: 'top',
      },
      body: {
        margin: '0 !important',
        lineHeight: '1',
        background: 'white',
        color: 'black',
      },
      q: {
        quotes: '"" ""',
      },
      'ul, ol, dir, menu': {
        listStyle: 'none',
        paddingLeft: 0,
      },
      'sub, sup': {
        verticalAlign: 'baseline',
      },
      a: {
        textDecoration: 'none',
        color: 'inherit',
      },
      hr: {
        display: 'none',
      },
      font: {
        color: 'inherit !important',
        font: 'inherit !important',
      },
      marquee: {
        overflow: 'inherit !important',
        MozBinding: 'none',
      },
      blink: {
        textDecoration: 'none',
      },
      nobr: {
        whiteSpace: 'normal',
      },
    },
  });

Reset.displayName = 'Monterey(Reset)';
TP.displayName = 'Monterey(EmotionThemeProvider)';

const ThemeProvider = ({ children, reset = true, theme = {}, ...props }) => {
  return (
    <TP theme={{ ...theme, ...tokens }} {...props}>
      <React.Fragment>
        {reset && <Reset />}
        {children}
      </React.Fragment>
    </TP>
  );
};

ThemeProvider.displayName = 'Monterey(ThemeProvider)';

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
  reset: PropTypes.bool,
  theme: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

ThemeProvider.defaultProps = {
  reset: true,
  theme: tokens,
};

function useTheme() {
  return tokens;
}

export { useTheme, tokens as theme, ThemeProvider as default };
